<template>
  <div class="tips-selector" v-if="tips">
    <div class="header">
      <span class="title">{{ text('cp_tips_switcher_text') }}</span>
      <SwitchInput v-model="checked"/>
    </div>
    <input
        v-show="checked"
        type="number"
        name="count"
        v-model="tipsSum"
        placeholder="Сумма"
        class="input"
    >
    <div
        class="add-sum-wrapper"
        v-show="checked && plusMoneyButtons.length"
    >
      <div class="add-sum">
        <div
            v-for="(button, buttonId) in plusMoneyButtons"
            v-show="button"
            :key="`button${buttonId}`"
            class="tips-plus-button"
            @click="tipsSum = button"
        >
          <span
              class="plus-sum"
              :class="{ 'ios-font': $store.getters.checkIos }"
          >
            {{ button }} ₽
          </span>
        </div>
      </div>
    </div>
    <span
        v-show="checked"
        class="tips-hint"
    >
      {{ text('cp_tips_help_text') }}
    </span>
  </div>
</template>

<script>
import SwitchInput from "@/components/Default/Input/SwitchInput.vue";

const ONLINE_METHOD_ID = 1
const CP_PROVIDER_ID = 3

export default {
  name: 'TipsSelector',

  components: { SwitchInput },

  props: {
    paymentMethod: Object,
    defaultMethod: Object,
  },

  data() {
    return {
      maxSum: '10000',
      tipsSum: '',
      checked: false,
    }
  },

  computed: {
    tips() {
      if (
          !this.paymentMethod ||
          this.paymentMethod.id !== ONLINE_METHOD_ID ||
          this.$store.getters.outletSettings.payment_provider_id !== CP_PROVIDER_ID ||
          !this.paymentMethod.hasOwnProperty('tips') ||
          !this.paymentMethod.tips.cp_tips_enable
      ) {
        return null
      }
      return this.paymentMethod.tips
    },
    plusMoneyButtons() {
      if (
          !this.tips ||
          !this.tips.hasOwnProperty('cp_tips_plus_money') ||
          !Array.isArray(this.tips.cp_tips_plus_money)
      ) {
        return []
      }
      return this.tips.cp_tips_plus_money.filter(sum => !!sum)
    },
  },

  methods: {
    setDefaultSwitchState() {
      if (!this.tips || !this.tips.cp_tips_default_value) {
        return
      }
      this.checked = true
    },
    setDefaultTipsSum() {
      if (!this.tips || !this.tips.cp_tips_default_value) {
        return;
      }
      this.tipsSum = String(Math.floor(this.$store.getters.totalPrice / 100 * this.tips.cp_tips_default_value))
    },
  },

  watch: {
    tips: function(update) {
      if (!update) {
        return;
      }
      this.setDefaultSwitchState()
      this.setDefaultTipsSum()
    },
    tipsSum: function(update) {
      this.$nextTick(async () => {
        if (+update > +this.maxSum) {
          this.tipsSum = this.maxSum
        }
      })
    }
  },
}
</script>

<style scoped>
.tips-selector {
  margin: 35px 0 18px;
  border: 1px solid #0084ff;
  border-radius: 16px;
  padding: 20px;
}

.tips-selector .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tips-selector .title {
  font-weight: 500;
  font-size: 20px;
  line-height: 120%;
  color: #000;
}

.tips-selector .input {
  margin: 32px 0 16px;
  padding: 6px 16px;
  width: calc(100% - 40px);
  font-family: inherit;
  font-size: 15px;
  color: #1a1a1b;
  font-weight: 500;
  border: none;
  border-bottom: 1px solid #f0f0f0;
}

.tips-selector .input::placeholder {
  font-size: 15px;
  color: #999;
  font-weight: 400;
}

.add-sum-wrapper {
  position: relative;
  margin: 0 -20px 8px;
}

.add-sum-wrapper::before,
.add-sum-wrapper::after {
  content: "";
  position: absolute;
  width: 30px;
  height: 100%;
  top: 0;
}

.add-sum-wrapper::before {
  left: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 0) 100%);
}

.add-sum-wrapper::after {
  right: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 90%);
}

.add-sum {
  display: flex;
  padding: 0 20px;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.add-sum::-webkit-scrollbar {
  display: none;
}

.tips-plus-button {
  padding: 11px 16px;
  background-color: #f5f5f5;
  margin-bottom: 8px;
}

.tips-plus-button:first-child {
  border-radius: 16px 0 0 16px;
}

.tips-plus-button:last-child {
  border-radius: 0 16px 16px 0;
}

.tips-plus-button .plus-sum {
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #0084ff;
  white-space: nowrap;
}

.tips-hint {
  display: flex;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #999999;
  margin-bottom: 10px;
}
</style>
